import React, { useState } from 'react';
import { Tabs } from 'antd';
import BlogsTable from '../NewToStrum/BlogsTable/BlogsTable';
import ProductsTable from '../NewToStrum/ProductsTable/ProductsTable';
import QuestionsTable from '../NewToStrum/QuestionsTable/QuestionsTable';
import BucketsTable from '../NewToStrum/BucketsTable/BucketsTable';
import VideosTable from '../NewToStrum/VideosTable/VideosTable';
import ProductTypesTable from '../NewToStrum/ProductTypesTable/ProductTypesTable';
import TagsTable from '../NewToStrum/TagsTable/TagsTable';

const NavigationNewToStrum = () => {
  const [activeTab, setActiveTab] = useState('questions');

  const customTabBar = (props, DefaultTabBar) => (
    <div className="TabListTopBox">
      <DefaultTabBar {...props} />
    </div>
  );

  const items = [
      {
      key: 'questions',
      label: 'Questions',
      children: <QuestionsTable />,
    },
    {
      key: 'products',
      label: 'Products',
      children: <ProductsTable />,
    },
    {
      key: 'blogs',
      label: 'Blogs',
      children: <BlogsTable />,
    },
    {
      key: 'videos',
      label: 'Videos',
      children: <VideosTable />,
    },
    {
      key: 'buckets',
      label: 'Buckets',
      children: <BucketsTable />,
    },
    {
      key: 'product-types',
      label: 'Product Types',
      children: <ProductTypesTable />,
    },
    {
      key: 'tags',
      label: 'Global Tags',
      children: <TagsTable />,
    },
  ];

  return (
    <div className='TopTablesTabsBox TabNavigation'>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        renderTabBar={customTabBar}
        className='TopTablesTabs'
        items={items}
      />
    </div>
  );
};

export default NavigationNewToStrum;
